import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function ScrollButton({
  children,
  className = ''
}: ButtonProps) {
  const scrollToPricing = () => {
    const el = document.getElementById('comprar');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={scrollToPricing} className={`bg-orange-500 hover:bg-orange-600 text-white font-display text-2xl md:text-3xl tracking-wide py-4 px-8 rounded-sm transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(249,115,22,0.3)] hover:shadow-[0_0_40px_rgba(249,115,22,0.5)] ${className}`} data-id="element-92">
      {children}
    </button>;
}